import React from 'react';
import { Clock, Shield, AlertTriangle, Download } from 'lucide-react';
const MOCK_ACTIVITY = [{
  id: 1,
  action: 'Login Successful',
  device: 'Chrome on MacOS',
  ip: '192.168.1.1',
  time: '2 mins ago',
  status: 'success'
}, {
  id: 2,
  action: 'Payment Method Added',
  device: 'Chrome on MacOS',
  ip: '192.168.1.1',
  time: '1 hour ago',
  status: 'success'
}, {
  id: 3,
  action: 'Password Changed',
  device: 'Mobile App (iOS)',
  ip: '10.0.0.5',
  time: '2 days ago',
  status: 'warning'
}, {
  id: 4,
  action: 'Document Uploaded',
  device: 'Chrome on MacOS',
  ip: '192.168.1.1',
  time: '3 days ago',
  status: 'success'
}, {
  id: 5,
  action: 'Failed Login Attempt',
  device: 'Unknown Device',
  ip: '45.32.11.90',
  time: '5 days ago',
  status: 'danger'
}];
export function ActivityLog() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2053">
      <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center" data-id="element-2054">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-2055">Recent Activity</h3>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center" data-id="element-2056">
          <Download className="h-4 w-4 mr-1" data-id="element-2057" />
          Export Log
        </button>
      </div>

      <div className="divide-y divide-gray-100" data-id="element-2058">
        {MOCK_ACTIVITY.map(activity => <div key={activity.id} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-2059">
            <div className="flex items-center" data-id="element-2060">
              <div className={`p-2 rounded-full mr-4 ${activity.status === 'success' ? 'bg-green-100 text-green-600' : activity.status === 'warning' ? 'bg-yellow-100 text-yellow-600' : 'bg-red-100 text-red-600'}`} data-id="element-2061">
                {activity.status === 'success' ? <Shield className="h-4 w-4" data-id="element-2062" /> : <AlertTriangle className="h-4 w-4" data-id="element-2063" />}
              </div>
              <div data-id="element-2064">
                <p className="text-sm font-medium text-gray-900" data-id="element-2065">
                  {activity.action}
                </p>
                <p className="text-xs text-gray-500" data-id="element-2066">
                  {activity.device} • {activity.ip}
                </p>
              </div>
            </div>
            <div className="flex items-center text-xs text-gray-400" data-id="element-2067">
              <Clock className="h-3 w-3 mr-1" data-id="element-2068" />
              {activity.time}
            </div>
          </div>)}
      </div>

      <div className="px-6 py-3 bg-gray-50 border-t border-gray-100 text-center" data-id="element-2069">
        <button className="text-xs text-gray-500 hover:text-gray-700 font-medium" data-id="element-2070">
          View Full History
        </button>
      </div>
    </div>;
}